import React, { useState } from "react";
import { Button } from "antd";

export const QuestionForm = ({ questions }) => {
  const [disabledQuestions, setDisabledQuestions] = useState(
    questions.map(() => false), // Initialize an array of `false` for all questions
  );

  const handleCheckboxChange = (index) => {
    const updatedDisabledQuestions = [...disabledQuestions];
    updatedDisabledQuestions[index] = !updatedDisabledQuestions[index]; // Toggle the disabled state
    setDisabledQuestions(updatedDisabledQuestions);
  };

  const labelStyles = {
    color: "#666666",
    fontWeight: "400",
    marginBottom: "5px",
    fontSize: "15px",
    display: "block",
  };
  const commonStyles = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    borderRadius: "8px",
    backgroundColor: "#D9D9D98C",
    boxSizing: "border-box",
  };
  const renderFieldByType = (question, disabled) => {
    switch (question.type) {
      case "text":
      case "number":
      case "password":
      case "email":
      case "tel":
      case "url":
      case "search":
      case "date":
      case "time":
      case "week":
      case "month":
      case "datetime-local":
      case "color":
      case "range":
        return (
          <input
            type={question.type}
            placeholder={`e.g.${question.placeholder}` || ""}
            style={commonStyles}
            disabled={!disabled}
          />
        );
      case "checkbox":
      case "radio":
        return (
          <div>
            <label>
              <input type={question.type} disabled={!disabled} />
              {question.label || question.question}
            </label>
          </div>
        );

      case "select":
        return (
          <select style={commonStyles} disabled={!disabled}>
            <option value="">-- Select an option --</option>
            {question.options?.map((option) => (
              <option key={option._id} value={option.value}>
                {option.key}
              </option>
            ))}
          </select>
        );
      default:
        return (
          <p style={{ color: "red" }}>
            Unsupported field type: <strong>{question.type}</strong>
          </p>
        );
    }
  };
  return (
    <form>
      <div>
        {questions.map((question, index) => (
          <div key={index} style={{ marginBottom: "20px" }}>
            <div className="flex items-center gap-2">
              {/* Checkbox to toggle question disabled state */}
              <input
                type="checkbox"
                checked={disabledQuestions[index]}
                onChange={() => handleCheckboxChange(index)}
              />
              {/* Render label */}
              {question.label && (
                <label style={labelStyles}>{question.label}</label>
              )}
              {question.question && !question.label && (
                <label style={labelStyles}>{question.question}</label>
              )}
            </div>
            <div>{renderFieldByType(question, disabledQuestions[index])}</div>
          </div>
        ))}
        <div className="flex justify-center px-20 gap-10 p-5">
          <Button
            type="primary"
            style={{
              background: "#fff",
              height: "40px",
              width: "150px",
              borderRadius: "10px",
              border: "1px solid #ebedf3",
            }}
            className="text-base font-normal text-black"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={{
              background: "linear-gradient(90deg, #3FC28A 0%, #00249B 100%)",
              height: "40px",
              width: "150px",
              borderRadius: "10px",
            }}
            className="text-base font-normal"
          >
            Save
          </Button>
        </div>
      </div>
    </form>
  );
};
